import { useEffect, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router';

import { TagDetails } from '../TagDetails/TagDetails';
import { LanguageType } from '@lifeserver/shared';

import { useCreateTag } from '../../hooks/tags';

import { RouteTo } from '../../routes';

import { CreateOrUpdateTag } from '../../types/tagTypes';

import { createEmptyTag } from '../emptyTag';

type TagProps = { language: LanguageType };

export const TagCreatePage = (props: TagProps) => {
    const { tagId, isLoading: isCreateTagLoading, createTag } = useCreateTag();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const prefilledName = searchParams.get('name')?.trim() ?? '';

    const initialTag = useMemo<CreateOrUpdateTag>(() => {
        const tag = createEmptyTag();

        if (prefilledName) {
            tag.name[props.language] = prefilledName;
        }

        return tag;
    }, [prefilledName, props.language]);

    useEffect(() => {
        if (tagId) {
            navigate(RouteTo.TagEdit(tagId.toString()));
        }
    }, [tagId]);

    async function onSave(tag: CreateOrUpdateTag) {
        try {
            await createTag(tag);
            return true;
        } catch {
            return false;
        }
    }

    return (
        <TagDetails
            language={props.language}
            isNew={true}
            onSave={onSave}
            initialTag={initialTag}
            isSaving={isCreateTagLoading}
        />
    );
};
